import './deviceUsageReport.less';

import {
    sendApiRequest,
    globalErrorHandler,
    getManagersMenu
} from '../../js/api';

import {dialogBox} from '../dialogBox/dialogBox';
import {monthPicker} from '../monthPicker/monthPicker';

// 包含經銷客戶的 comPicker (與授權碼報表共用)
import {comPicker} from '../licenseUsageReport/comPicker';

import _orderBy from 'lodash/orderBy';
import _filter from 'lodash/filter';
import _groupBy from 'lodash/groupBy';

import {showFeedbackMsg} from '../../js/helper/feedbackMsg';

// table 欄位設定
import {tableMap} from '../../setting/tableMap/deviceUsageReport';

// 匯出 xlsx
import {exportXlsx} from '../../js/helper/exportXlsx';

import {sideInfoBox} from '../sideInfoBox/sideInfoBox';

import {parseDatetime} from '../../js/helper/helper';

// 多選選擇器
import '../../web-components/select-multi/select-multi';

// 測試資料，不使用時需取消 import
// import * as sampleData from './sample/ec912-202506';

export class deviceUsageReport {

    constructor(btnContainer, roleCode){

        if(!btnContainer){
            return;
        }

        // 插入觸發按鈕的 dom
        this.btnContainer = btnContainer;

        // 權限代碼 (小寫) ex 'cem'
        this.roleCode = roleCode;

        // 需要取得 managersMenu 來建立公司列表
        this.managersMenu = null;

        // dialogBox
        this.box = null;

        // box 中的內容區塊 DOM
        this.boxContent = null;

        // 公司選擇器
        this.durComPicker = null;

        // 年月選擇器
        this.durMonthPicker = null;

        // 儲存報告資料用來匯出，包含 summary 與 records
        this.reportData = {};

        // 顯示查詢裝置轉移紀錄的元件 (device transfer log)
        this.dtlBox = null;

        // 裝置狀態名詞對照
        this.lang_active = window.langTxt.fieldParse.active;
        // 欄位名稱對照
        this.uiTxt = window.langTxt.deviceUsageReport;

        // 裝置狀態的顯示順序
        this.statusOrder = [
            // 啟用 / 未啟用 / 停用 / 備品 / 樣品 / 已回收
            'billed', 'enabled', 'disabled', 'spare', 'sample', 'deleted',
        ]

        // 多選選擇器
        this.multiSelect = null;

        // i18n
        this.deviceReportText = window.t('deviceReport');

        // 不使用測試資料時需取消 import
        this.useSampleData = false;

        this.init();
        this.events();

    }

    async init(){

        // 加入觸發按鈕
        this.addTriggerBtn();

        // 建立 dialogBox
        this.box = new dialogBox('deviceUsageReportBox', false, false);

        // 初始化 dialogBox 內容
        this.initBoxContent();

        // 顯示查詢裝置轉移紀錄的元件
        this.dtlBox = new sideInfoBox('deviceTransferLogBox');
    }

    events(){

        // trigger events
        document.querySelector('#deviceUsageReportTrigger')
        .addEventListener('click', (event) => {
            this.box.open();
        });


        // box events
        const boxContainer = this.box.container;
        boxContainer.addEventListener('click', (event) => {

            // 關閉，關閉時不清空內容
            if(event.target.id === 'closeDeviceUsageReportBox'){
                this.box.close(false);
            }

            // 送出查詢
            if(event.target.id === 'durQuerySubmit'){
                this.submitDurQuery();
            }

            // 匯出報表
            if(event.target.id === 'exportDeviceUsageReportBox'){
                // 開啟多選選擇器
                this.selectExportSheet();
            }

            // 查詢裝置轉移紀錄
            if(event.target.classList.contains('btn-translog')){
                const dataset = event.target.dataset;
                this.queryTransferLog(dataset.sn, dataset.model);
            }

        });

        // 多選選擇器 confirm
        boxContainer.addEventListener('select-multi-confirm', (e) => {
            // 關閉多選選擇器 (選擇器仍保留在 DOM 中)
            const host = e.detail.host;
            if(host){
                host.setAttribute('visibility', 'hidden');
            }
            // 匯出報表
            this.exportReportData(e.detail.data);
        });

        // 多選選擇器 transition 結束後從 DOM 中移除
        boxContainer.addEventListener('select-multi-transitionend', (e) => {
            const host = e.detail.host;
            if(host){
                host.remove();
            }
        });

    }

    /* ----- 加入觸發按鈕 ----- */
    addTriggerBtn(){

        const btn = document.createElement('div');
        btn.id = 'deviceUsageReportTrigger';
        btn.className = 'btn-control';
        btn.innerHTML =
        `<svg>
            <use xlink:href="/assets/sprites/sprites_solid.svg#poll-h"></use>
        </svg>${this.deviceReportText.openButton}`;

        this.btnContainer.appendChild(btn);
    }

    /* ----- 初始化 dialogBox 內容 ----- */
    async initBoxContent(){

        const boxDom = this.box.container;
        this.boxContent = boxDom.querySelector('.innerwpr');

        boxDom.classList.add('no-data');

        document.body.classList.add('loading');

        // get managersMenu data
        this.managersMenu = await getManagersMenu();

        const titleHtml =
        `<svg class="title-icon">
            <use xlink:href="/assets/sprites/sprites_solid.svg#poll-h"></use>
        </svg>
        <p>${this.deviceReportText.mainTitle}</p>
        <div class="control-menu">
            <div id="durComPicker" class="picker"></div>
            <div id="durMonthPicker" class="picker"></div>
            <div id="durQuerySubmit">${this.deviceReportText.submitButton}</div>
        </div>`;

        this.box.set_title(titleHtml);

        // 設定按鈕，關閉與匯出
        const boxBtn =
        `<div class="btn" id="closeDeviceUsageReportBox">關閉</div>
        <div class="btn white" id="exportDeviceUsageReportBox">匯出為 Excel</div>
        `;
        this.box.set_btnwpr(boxBtn);

        // 實體化 comPick 公司選擇器
        this.durComPicker = new comPicker(
            this.managersMenu.data.coms,
            document.getElementById('durComPicker')
        )

        // 實體化 monthPicker 年月選擇器
        this.durMonthPicker = new monthPicker({
            container: document.getElementById('durMonthPicker'),
            // startYear: '2020', // TEST
            // endYear: '2024',   // TEST
            monthNames: window.t('monthNames')
        });

        // 內容區加入空白提示
        this.boxContent.innerHTML =
        `<div class="empty-hint">
            <div class="content">
                <h4>歡迎使用裝置月報表查詢</h4>
                <p>請選擇公司與年份、月份</p>
            </div>
        </div>`;

        document.body.classList.remove('loading');
    }

    /* ----- 送出查詢 ----- */
    async submitDurQuery(){

        const comPickData = this.durComPicker.pick;
        const monthPickData = this.durMonthPicker.pick

        if(!comPickData.comId){
            showFeedbackMsg('尚未選擇公司', 'fail');
            return;
        }

        if(!monthPickData.year || !monthPickData.month){
            showFeedbackMsg('日期選擇錯誤', 'fail');
            return;
        }

        let setting = {};

        const comId = parseInt(comPickData.comId, 10);
        const comTypes = parseInt(comPickData.types, 10);

        if(comTypes === 2){
            // 經銷商
            setting.distributor_id = comId;
        } else {
            // 非經銷商
            setting.company_id = comId;
        }

        // 使用者選擇的年用，格式是字串 ex: 2023-06
        const monthPick = monthPickData.text;

        setting.report_month = monthPick;

        document.body.classList.add('loading');

        let apiData = null;
        if(this.useSampleData && sampleData){
            apiData = sampleData.default;
        } else {
            try {
            apiData = await sendApiRequest('post', '/coms/deviceUsageReport', setting)
                .then(res => res.data);
            } catch(error){
                globalErrorHandler(error);
                // ...其他錯誤處理程序
            }
        }

        document.body.classList.remove('loading');

        this.showReportData(apiData.data, comPickData, monthPick);
    }

    /* ----- 顯示查詢到的報表資料 ----- */
    // 摘要 Data.summary
    // 資料 Data.records
    // monthPick: 使用者選擇的年用，格式是字串 ex: 2023-06
    showReportData(Data, comPick, monthPick){

        const boxDom = this.box.container;

        // 清空 this.reportData (匯出報表時使用的資料)
        this.reportData = {};

        // 沒有資料
        if(Data.records.length < 1){
            const emptyHint =
            `<div class="empty-hint">
                <div class="content">
                    <h4>無報表資料</h4>
                    <p>${comPick.name} / ${monthPick}</p>
                </div>
            </div>`;

            boxDom.classList.add('no-data');
            this.boxContent.innerHTML = emptyHint;

            return;
        }

        // 取第一筆資料當範例，找出報表起迄日期 report_start / report_end
        const firstData = Data.records[0];

        // 報表起訖時間
        const startDate = firstData.report_start;
        const endDate = firstData.report_end;

        const comTypes = window.t('parseField.comTypes');

        // 顯示在畫面上的報表起訖日
        const reportDate =
        `<div class="date">${this.dateTimeHtml(startDate)} ~ ${this.dateTimeHtml(endDate)}</div>`;

        const sumPanel =
        `<div class="sumPanel">
            <div class="info">
                <div class="group">
                    <div class="tag comid"># ${comPick.comId}</div>
                    <div class="tag type">${comTypes[comPick.types]}</div>
                    <h4>${comPick.name}</h4>
                </div>
                ${reportDate}
            </div>

            <div class="device-sum-panel">${this.sumEntries(Data.summary)}</div>
        </div>`;

        /* ----- 顯示報表內容 ----- */
        const reportPanel =
        `<div class="reportPanel">
            ${this.tableContent(Data.records)}
        </div>`;

        boxDom.classList.remove('no-data');
        this.boxContent.innerHTML = `${sumPanel}${reportPanel}`;

        // 儲存整理後的報表資料，供匯出時使用
        // 1. 公司名稱與報表起訖日
        this.reportData.companyName = comPick.name;
        this.reportData.startDate = parseDatetime(startDate, true);
        this.reportData.endDate = parseDatetime(endDate, true);
        // 2. this.reportData.summary 在 this.sumEntries 中儲存
        // 3. this.reportData.records 在 this.tableContent 中儲存

        // console.log(this.reportData);
    }

    // === 摘要 === //
    // data: 來自 API 返回的 summary 資料
    sumEntries(data){

        // 整理後的資料
        const summary = {};

        for(const prop in data){
            /*
            * prop 是裝置型號，例如 CAB2001S
            * 對應 records 資料中的 'model_name' 欄位
            * data[prop] 是 server 計算此裝置各種狀態的數量，資料範例如下
            "CAB2001S": {
                "sample": 0,
                "spare": 0,
                "billed": 27,
                "enabled": 5,
                "disabled": 2,
                "deleted": 69
            }
            */

            // 型號一律大寫
            const modelName = prop.toUpperCase();

            // server 計算的各狀態數量
            const count = data[prop];

            // 不明型號的裝置
            if(modelName === 'UNKNOWN' || modelName.length < 1){
                if(summary['UNKNOWN']){
                    // 需要將此不明型號裝置，各狀態的數量，整併到 UNKNOWN 分類中
                    for(const status in count){
                        summary['UNKNOWN'][status] += count[status];
                    }
                } else {
                    summary['UNKNOWN'] = count;
                }
            } else {
                summary[modelName] = count;
            }
        }

        // 將 summary 轉換成 Array，以便進行排序
        const Arr = [];

        for(const prop in summary){
            Arr.push({
                modelName: prop,
                count: summary[prop]
            });
        }
        // 按照型號名稱排序
        const result = _orderBy(Arr, 'modelName', 'asc');

        let slotCounts = 0; // 計算 slot 的數量，最後要保持雙數

        let Html = '';

        result.forEach((item) => {

            // 計算各狀態的總數
            let total = 0;

            let cells = '';

            // 各狀態的數量
            this.statusOrder.forEach((status) => {

                // 數量
                const num = item.count[status];

                // 數量為 0 的樣式
                const empty = (num < 1)? ' empty' : '';

                // ex: 使用中：2
                cells +=
                `<div class="cell${empty}">
                    ${this.uiTxt[status]}：${num}
                </div>`;

                total += num;
            });

            Html +=
            `<div class="slot">
                <div class="cell name">${item.modelName} (${total})</div>
                ${cells}
            </div>`;

            slotCounts += 1;
        });

        // 為了保持 layout 平衡，slot 需要是雙數，以維持寬度為 50%
        if(slotCounts % 2 !== 0){
            Html += '<div class="slot spacer"></div>';
        }

        this.reportData.summary = result;

        return Html;
    }

    // ----- 顯示在畫面上的日期時間資料 (報表起訖日) ----- //
    dateTimeHtml(data){

        const datetime = parseDatetime(data);

        if(!datetime){
            return '';
        }
        // 時間用較小的文字顯示
        return `${datetime.date.display} <small>${datetime.time}</small>`;
    }

    /* ----- 報表內容 HTML ----- */
    tableContent(Data){
        // 資料排序規則：公司 -> 型號 -> 量測次數，由多到少排序
        const orderedData = _orderBy(
            Data, ['company_id', 'model_name', 'test_count'], ['desc', 'asc', 'desc']
        )

        // 儲存 records 資料
        this.reportData.records = orderedData;

        // 欄位名稱
        const fieldName = this.uiTxt;

         let tableHead = ''; // table head

         let tableBody = ''; // table body

         tableMap.forEach((mapItem) => {

            let pass = true;

            // 根據權限設定是否要顯示欄位
            if(mapItem.hasOwnProperty('permission')){
                const permission = mapItem.permission;
                if(!permission.includes(this.roleCode)){
                    pass = false;
                }
            }

            if(pass){
                const key = mapItem.key;
                // 欄位名稱
                tableHead += `<th class="${key}">${fieldName[key]}</th>`;
            }
         });

         orderedData.forEach((dataItem) => {
            tableBody += `<tr class="status-${dataItem.device_status}">`;
            // tableBody += `<tr class="status--2">`;

            tableMap.forEach((mapItem) => {

                let pass = true;

                // 根據權限設定是否要顯示欄位
                if(mapItem.hasOwnProperty('permission')){
                    const permission = mapItem.permission;
                    if(!permission.includes(this.roleCode)){
                        pass = false;
                    }
                }

                if(pass){
                    const key = mapItem.key;
                    const output = this.preprocess(key, dataItem);

                    let content = '';
                    if(key === 'device_status' && output.length > 0){
                        // 裝置狀態
                        content = `<span class="status">${output}</span>`;
                    } else {
                        content = output;
                    }

                    // 表格資料
                    tableBody += `<td class="${key}">${content}</td>`;
                }
             });

            tableBody += '</tr>';
         });

        const html =
        `<table>
            <thead><tr>${tableHead}</tr></thead>
            <tbody>${tableBody}</tbody>
        </table>`;

        return html;
    }

    /* ----- 欄位資料處理 ----- */
    preprocess(key, dataItem, exportData = false){

        // exportData: 是否為匯出，匯出的時候不包含 html 標籤

        let output = dataItem[key]; // 資料原始值

        // 空值
        if(
            dataItem[key] === null || dataItem[key] === undefined ||
            dataItem[key] === 'null' ||
            dataItem[key] === ''
        ){
            if(key === 'test_count'){
                // 量測次數如果沒資料的話顯示為 0
                if(exportData){
                    output = '0';
                } else {
                    output = '<span class="fade">0</span>';
                }

            } else {
                output = '';
            }
        }

        // 累計量測次數
        if(key === 'device_count_total' && output === 0){
            if(exportData){
                output = '0';
            } else {
                output = '<span class="fade">0</span>';
            }
        }

        // 裝置狀態 (device_status)，等同於 device 的 active 值
        if(key === 'device_status'){
            if(this.lang_active[output]){
                output = this.lang_active[output];
            }
        }

        // 查詢裝置轉移紀錄
        // 使用序號查詢，如果序號是空的或 PunchIn，則按鈕為 disabled 狀態
        if(key === 'transfer_log'){

            let sn = dataItem.serial_no;
            let btnClass = '';

            if(!sn || sn.toLowerCase() === 'punchin' || sn.length < 1){
                sn = 'disabled';
                btnClass = ' disabled';
            }

            const model = (dataItem.model_name)? dataItem.model_name : 'Unknown';

            output =
            `<div class="btn btn-translog${btnClass}" data-sn="${sn}" data-model="${model}">查詢</div>`;
        }

        // 日期相關欄位
        if(
            key === 'earliest_time' || key === 'latest_time' ||
            key === 'checkin_time' || key === 'last_updated'
        ){

            let result = '';

            const datetime = parseDatetime(output);

            if(datetime){
                if(exportData){
                    // 匯出資料
                    result = datetime.output;
                } else {
                    // 畫面顯示
                    result =
                    `<span class="date d1">${datetime.date.display}</span>
                    <span class="date d2">${datetime.time}</span>`;
                }
            }
            return result;
        }

        // 型號一律轉換為大寫
        if(key === 'model_name'){
            if(output && output.length > 0){
                output = output.toUpperCase();
            }
        }

        return output;
    }

    // === 匯出報表前，選擇要匯出的 sheet === //
    selectExportSheet(){

        if(!this.reportData.summary){
            showFeedbackMsg(uiText.message.noData, 'fail');
            return;
        }

        // 一個 xlsx 檔中可生成多個 sheet，在此指定各個 sheet 的名稱 (相當於資料分頁)
        // Duplicate: 單獨列出「序號重複出現的裝置」
        const sheetName = [
            'Summary', 'All',
            // 'Duplicate' // 改成在 exportReportData 中再檢查是否有重複序號
        ];

        // 所有型號的列表
        const modelNameList = this.reportData.summary.map((item) => {
            return item.modelName;
        });

        // 根據 summary 中列出的型號建立對應的 sheet
        sheetName.push(...modelNameList);

        // 建立多選選擇器
        this.multiSelect = document.createElement('select-multi');
        this.multiSelect.setAttribute('mode', 'dialog');
        this.box.container.appendChild(this.multiSelect);

        // 將 sheetName 整理成需要的格式
        const options = sheetName.map((item) => {
            const result = {
                text: item,
                value: item,
            }
            switch(item){
                case 'Summary':
                case 'All':
                    // 不可選擇
                    result.disabled = true;
                    break;
                // case 'Duplicate':
                //     // 略過不建立選項
                //     result.skip = true;
                //     break;
            }
            return result;
        });

        this.multiSelect.setData = {
            title: window.t('common.hint.selectSheetsExport'), // 選擇要匯出的資料表
            name: 'sheetexport',
            options: options,
        };

    }

    /* ----- 匯出報表資料 ----- */
    exportReportData(sheetName){
        /*
        數量統計資料 this.reportData.summary
        裝置資料 this.reportData.records
        需要準備：
            1. sheetName: 在 xlsx 中要產生的 sheet 名稱
            2. sheetHeader: 欄位名稱與顯示順序
            3. sheetData: 資料
        */

        // deviceUsageReport
        const uiText =  this.uiTxt;

        // sheetName 在 selectExportSheet 中整理

        // sheetHeader 指定需要顯示的欄位以及顯示順序
        // 範例格式如下 (相當於各欄位的 th 名稱和顯示順序 )
        const thReference = uiText.thReference;
        /*
        thReference: {
            summary: [
                '型號', '使用中', '待命', '已停用', '備品', '樣品', '已刪除',
                '報表起算日', '報表結束日'
            ],
            record: [
                '經銷商', '公司', '型號', '序號', '授權碼', '狀態', '量測次數',
                '最初量測時間', '最後量測時間', 'Check-in 時間', '最後更新時間'
            ]
        },
        */
        const sheetHeader = {};
        sheetName.forEach((name) => {
            if(name === 'Summary'){
                // summary 跟其他的 sheet 的 table header 不同
                sheetHeader[name] = thReference.summary;
            } else {
                sheetHeader[name] = thReference.record;
            }
        });

        // sheetData 報表資料，需整理成以下範例格式
        // sheet 的 key 值對應 sheetName
        // 個別資料物件中的 key 值對應 sheetHeader 中的欄位名稱
        /*
        {
            'Summary': [{
                型號: 'CAB2000S',
                使用中: 10,
                待命: 1,
                ...
            }, ...],
            'All records': [{
                經銷商: 'xxx',
                公司: 'xxx',
                型號: 'xxx',
                序號: 'xxx',
                ...
            }, ...]
        }
        */
        // 此處先根據 sheetName 來產生空白的 sheetData
        const sheetData = {};
        sheetName.forEach((item) => {
            sheetData[item] = [];
        });

        // Step 1. sheetData.Summary
        this.reportData.summary.forEach((item) => {
            /*
            // 資料範例
            {
                "modelName": "ALC10BG1",
                "count": {
                    "sample": 0,
                    "spare": 0,
                    "billed": 2,
                    "enabled": 0,
                    "disabled": 0,
                    "deleted": 0
                }
            }
            */
            const data = {
                modelName: item.modelName,
                ...item.count // 將 count 內的資料展開
            }

            const output = {};

            for(const key in data){
                const fieldName = uiText[key];
                output[fieldName] = data[key];
            }

            output['報表起算日'] = this.reportData.startDate;
            output['報表結束日'] = this.reportData.endDate;

            sheetData.Summary.push(output);
        });

        // Step 2. 各型號的裝置資料
        // 除了 'All' 之外，其他 sheet 需要根據型號 (model_name) 篩選
        const _rawData = this.reportData.records;

        // 避免在 forEach 過程中修改用來執行 forEach 的陣列
        // 如果需要新增或移除項目，要在原始的 sheetName 陣列中操作
        const _sheetNameClone = structuredClone(sheetName);

        // 此處的 sheet 即為裝置型號 (model_name) 值
        _sheetNameClone.forEach((sheet) => {

            if(sheet === 'Summary'){
                return;
            }

            // let result = null;

            /*
            if(sheet === 'All'){
                // deep clone all data
                result = structuredClone(_rawData);

            }

            if(sheet === 'Duplicate'){
                // 檢查是否有重複序號的裝置
                // 按序號 grouping
                const _composed = _groupBy(_rawData, 'serial_no');
                result = [];
                for(const sn in _composed){
                    const arr = _composed[sn];
                    // 數量大於 1，表示有序號重複的裝置
                    if(arr.length > 1){
                        // 存入 result 前需要先將 arr 攤平
                        result.push(...arr.flat());
                    }
                }
                if(result.length > 0){
                    // 如果沒有重複的序號
                    // 需要在 forEach 結束後刪除 sheetName 中的 'Duplicate'
                    // 注意不能在此刪除，否則 'Duplicate' 後一個項目會被錯誤的跳過
                    // 因為 sheetName 的原始資料已經被修改
                    hasDuplicate = true;
                }

            }

            else if(sheet === 'UNKNOWN'){
                // model_name: 'UNKNOWN' / null / 空字串
                result = _filter(_rawData, (o) => {
                    const modelName = o.model_name;
                    if(!modelName || modelName === 'UNKNOWN' || modelName.length < 1){
                        return true;
                    }
                });

            } else {
                // 根據型號篩選需要的資料
                result = _filter(_rawData, (o) => {
                    // 注意，統一轉成大寫來比對
                    // model_name 有可能是 null 或空字串
                    const modelName = o.model_name;
                    // console.log(modelName);
                    if(modelName && modelName.length > 0){
                        return modelName.toUpperCase() === sheet.toUpperCase();
                    }
                });
            }

            // if(!result){
            //     return;
            // }

            // 資料排序，有兩種排序規則
            // # Duplicate sheet
            // 1. 序號 serial_no
            // 2. 型號 model_name
            // 3. 最後量測時間 latest_time
            // # 其他 sheet
            // 1. 公司 (查詢經銷商時會包含經銷客戶的裝置)
            // 2. 型號 (只有在 All 時會有不同型號)
            // 3. 量測次數 (由多到少)
            // let _column = [];
            // let _order = [];
            // if(sheet === 'Duplicate'){
            //     _column = ['serial_no', 'model_name', 'latest_time'];
            //     _order = ['desc', 'asc', 'desc'];
            // } else {
            //     _column = ['company_id', 'model_name', 'test_count'];
            //     _order = ['desc', 'asc', 'desc'];
            // }

            // const orderedData = _orderBy(
            //     result, _column, _order
            // );
            */

            const result = this.exportDataFilter(_rawData, sheet);

            const index = sheetName.findIndex((o) => {
                return o.toUpperCase() === sheet.toUpperCase();
            });

            if(!result){
                // 如果沒有資料，刪除 sheetName 中對應的型號
                // 理論上不會發生這種情況，因為 sheetName 是根據 summary 資料建立
                sheetName.splice(index, 1);
                return;
            }

            // 整理成匯出需要的格式
            // 1. 只需保留 sheetHeader 中列出的項目
            // 2. 需整理成「型號: 'DB62M'」這樣的格式
            const header = sheetHeader[sheet];

            sheetData[sheet] = result.regular.map((item) => {
                const entry = {};
                for(const prop in item){
                    // 中文欄位名稱
                    const fieldName = uiText[prop];
                    // 只取需要的欄位資料 (只有在 sheetHeader 中列出的項目)
                    if(header.includes(fieldName)){
                        entry[fieldName] = `${this.preprocess(prop, item, true)}`;
                    }
                }
                return entry;
            });

            // 有重複序號的資料，將 sheet 加入到 sheetName 清單中
            // 需加入對應型號 sheet 的後方
            if(result.hasDuplicate){
                if(index > -1){
                    const _sheet = `${sheet}-Duplicate`;

                    sheetName.splice(index + 1, 0, _sheet);

                    // 注意：也需要加入對應的 sheetHeader
                    sheetHeader[_sheet] = structuredClone(sheetHeader[sheet]);

                    sheetData[_sheet] = result.duplicate.map((item) => {
                        const entry = {};
                        for(const prop in item){
                            // 中文欄位名稱
                            const fieldName = uiText[prop];
                            // 只取需要的欄位資料 (只有在 sheetHeader 中列出的項目)
                            if(header.includes(fieldName)){
                                entry[fieldName] = `${this.preprocess(prop, item, true)}`;
                            }
                        }
                        return entry;
                    });
                }
            }

        });

        const fileName =
        `${this.reportData.companyName}-${this.reportData.startDate.slice(0,10)}-${this.reportData.endDate.slice(0,10)}`;

        // 顯示載入中提示，這個提示會在 openDownloadDialog 中移除
        document.body.classList.add('loading');

        exportXlsx(sheetName, sheetData, sheetHeader, fileName);
    }

    // === 根據裝置型號篩選要匯出的資料 === //
    // 傳入的 sheet 為裝置型號 (model_name) 值
    exportDataFilter(data, sheet){

        let filtered = null;

        if(sheet === 'All'){
            filtered = data;
        } else if(sheet === 'UNKNOWN'){
            // model_name: 'UNKNOWN' / null / 空字串
            filtered = _filter(data, (o) => {
                const modelName = o.model_name;
                if(!modelName || modelName === 'UNKNOWN' || modelName.length < 1){
                    return true;
                }
            });

        } else {
            // 根據型號篩選需要的資料
            filtered = _filter(data, (o) => {
                // 需統一轉成大寫來比對，model_name 有可能是 null 或空字串
                const modelName = o.model_name;
                if(modelName && modelName.length > 0){
                    return modelName.toUpperCase() === sheet.toUpperCase();
                }
            });
        }

        if(!filtered){
            return false;
        }

        // 檢查是否有重複序號的裝置
        let hasDuplicate = false;

        // 先按照序號 按序號 grouping
        const _composed = _groupBy(filtered, 'serial_no');
        // grouping 後的資料格式
        // {
        //     PAB2001S: [{...}, {...}],
        //     CAB2001S: [{...}],
        // }
        const duplicate = [];
        for(const sn in _composed){
            const arr = _composed[sn];
            // 數量大於 1，表示有序號重複的裝置
            if(arr.length > 1){
                // 存入 result 前需要先將 arr 攤平
                duplicate.push(...arr.flat());
                hasDuplicate = true;
            }
        }

        // 資料排序 normal list
        // 1. 公司 (查詢經銷商時會包含經銷客戶的裝置)
        // 2. 型號 (只有在 All 時會有不同型號)
        // 3. 量測次數 (由多到少)
        const ordered = _orderBy(
            filtered,
            ['company_id', 'model_name', 'test_count'],
            ['desc', 'asc', 'desc']
        );

        // 資料排序 Duplicate
        let orderedDuplicate = null;
        // 1. 序號 serial_no
        // 2. 型號 model_name
        // 3. 最後量測時間 latest_time
        if(hasDuplicate){
            orderedDuplicate = _orderBy(
                duplicate,
                ['serial_no', 'model_name', 'latest_time'],
                ['desc', 'asc', 'desc']
            );
        }

        return {
            hasDuplicate: hasDuplicate,
            regular: ordered,
            duplicate: orderedDuplicate,
        }

    }

    /* ----- 查詢裝置轉移紀錄 ----- */
    // SN: 裝置序號
    async queryTransferLog(SN, ModelName){

        if(SN === 'disabled' || SN.length < 1){
            return;
        }

        document.body.classList.add('loading');

        let apiData = null;
        try {
            apiData = await sendApiRequest('post', '/devices/log', {
                serial_no: SN
            })
                .then(res => res.data);

        } catch(error){
            globalErrorHandler(error);
            // ...其他錯誤處理程序
        }

        this.dtlBox.set_title(
            `Model: ${ModelName}, SN: ${SN}`
        );

        // 檢查資料內容
        const Data = apiData.data;
        if(!Data || Data.length < 1 || !Array.isArray(Data)){
            this.dtlBox.set_noData();
        } else {
            this.dtlBox.set_content(
                this.transferLogTable(Data)
            );
        }

        document.body.classList.remove('loading');

        this.dtlBox.open();
    }


    /* ----- 產生裝置轉移紀錄資料表格 HTML ----- */
    transferLogTable(Data){

        // console.log(Data);

        // 欄位順序
        const dataOrder = [
            'company_sname', 'site_sname',
            'active', 'timestamp', 'initial_test_count'
        ]

        // 欄位名稱
        const colName = this.uiTxt.transferLog;

        // 裝置狀態名詞對照
        const parseActive = this.lang_active;

        let tableHead = '';
        let tableBody = '';

        function parseData(dataItem, key){
            let output = dataItem[key];
            if(key === 'active' && parseActive[output]){
                const text = parseActive[output];
                if(output === -2){
                    output = `<span class="disabled">${text}</span>`;
                } else {
                    output = text;
                }
            }
            return output;
        }

        Data.forEach((dataItem, index) => {

            tableBody += `<tr>`;

            dataOrder.forEach((key) => {
                // 藉由第一筆建立 table header
                if(index === 0){
                    // console.log(index);
                    tableHead += `<th class="${key}">${colName[key]}</th>`;
                }

                tableBody += `<td class="${key}">${parseData(dataItem, key)}</td>`;
            });

            tableBody += `</tr>`;
        });

        const Html =
        `<table>
            <thead><tr>${tableHead}</tr></thead>
            <tbody>${tableBody}</tbody>
        </table>`;

        return Html;
    }

}